import * as Types from 'src/actions/project/team-member/update/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import ValidatorService from 'src/services/validation/Validation.service';
import { Validation } from 'src/services/validation/Validator';
import ProjectTeamMember from 'src/value-objects/ProjectTeamMembers';

export interface UpdateProjectTeamMemberAttempt extends Action {
  type: Types.UPDATE_PROJECT_TEAM_MEMBER_ATTEMPT;
}

export interface UpdateProjectTeamMemberSuccess extends Action {
  type: Types.UPDATE_PROJECT_TEAM_MEMBER_SUCCESS;
}

export interface UpdateProjectTeamMemberFailure extends Action {
  type: Types.UPDATE_PROJECT_TEAM_MEMBER_FAILURE;
  payload: {};
}

export type UpdateProjectTeamMemberAction =
  UpdateProjectTeamMemberAttempt |
  UpdateProjectTeamMemberSuccess |
  UpdateProjectTeamMemberFailure;

export interface UpdateProjectTeamMemberThunk extends
  ThunkAction<Promise<UpdateProjectTeamMemberAction>, RootState, null> {
}

export const updateProjectTeamMemberAttempt: ActionCreator<UpdateProjectTeamMemberAttempt> = () => (
  {type: Types.UPDATE_PROJECT_TEAM_MEMBER_ATTEMPT}
);

export const updateProjectTeamMemberSuccess: ActionCreator<UpdateProjectTeamMemberSuccess> = () => (
  {
    type: Types.UPDATE_PROJECT_TEAM_MEMBER_SUCCESS,
  }
);

export const updateProjectTeamMemberFailure: ActionCreator<UpdateProjectTeamMemberFailure> = (error: {}) => (
  {
    type: Types.UPDATE_PROJECT_TEAM_MEMBER_FAILURE,
    payload: error
  }
);

export const updateProjectTeamMember: ActionCreator<UpdateProjectTeamMemberThunk> = (
  projectId: number, teamMember: ProjectTeamMember
): UpdateProjectTeamMemberThunk => {

  return (dispatch: Dispatch<RootState>): Promise<UpdateProjectTeamMemberAction> => {

    dispatch(updateProjectTeamMemberAttempt());

    let restrictions: Validation[] = [
      {value: teamMember.fullName, message: 'name'},
      {value: teamMember.jobTitle, message: 'jobTitle'},
      {value: teamMember.description, message: 'description'},
    ];

    const validation = ValidatorService.validate(restrictions);

    return validation.then(() => {

      return ApiClient.projectTeamMember.update('', teamMember, {projectId: projectId})
        .then((response: AxiosResponse): UpdateProjectTeamMemberSuccess => {
          return dispatch(updateProjectTeamMemberSuccess());
        }).catch((e: { response: { data: { errors: {} } } }): UpdateProjectTeamMemberFailure => {
          const errorMessages = ValidatorService
            .translateValidations(e && e.response && e.response.data && e.response.data.errors);

          return dispatch(updateProjectTeamMemberFailure(errorMessages));
        });
    }).catch((errors) => {
      return dispatch(updateProjectTeamMemberFailure(errors));
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/project/team-member/update/UpdateProjectTeamMember.actions.tsx